module.exports = __webpack_public_path__ + "static/media/wk-peace.8e086815.svg";